import React from "react";
import { connect } from "react-redux";

import { doGetAllUsers, doCreateUser, doUpdateUser, doDeleteUser } from "../stores/thunk";
import { selectAllUsers } from "../stores/slice";

import {
  doGetAllGroups,
  doUpdateGroupInviteEmail,
  doUpdateGroupDisInviteEmail,
  doGetGroupInviteEmails,
  doOffGroupInviteEmails,
} from "../../group/stores/thunk";
import { selectAllGroups } from "../../group/stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.user.isFetching || state.group.isFetching,
      isSucceeded: state.user.status === "succeeded" || state.group.status === "succeeded",
      metadata: state.user.metadata,
      invite: state.group.invite,
      auth: state.auth,
      users: selectAllUsers(state),
      groups: selectAllGroups(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllUsers,
    doCreateUser,
    doUpdateUser,
    doDeleteUser,
    doGetAllGroups,
    doUpdateGroupInviteEmail,
    doUpdateGroupDisInviteEmail,
    doGetGroupInviteEmails,
    doOffGroupInviteEmails,
  })(Container);
};
